import { createI18n } from 'vue-i18n'
import de from './locales/de.json'
import en from './locales/en.json'

export type AppLocale = 'de' | 'en'

export const messages = { de, en } as const

export const i18n = createI18n({
	legacy: false,
	locale: 'de',
	fallbackLocale: 'de',
	messages,
})
